import gql from 'graphql-tag'
import Constants from "../../Constants/Constants";

export const SUBSCRIBE_ALL_USERS = gql`
subscription {
  Users: Users{
    id
    name
    email
    mobile
    profileImage
    roleId
    Role {id role}
    created_at
    updated_at
    ipVerify
  }
}`

export const SUBSCRIBE_USERS_BY_TYPE = gql`
subscription ($roleId: uuid!){
  Users(where: {roleId: {_eq: $roleId}}){
    id
    name
    mobile
    email
    profileImage
  }
}`
export const SUBSCRIBE_USERS_COUNT_BY_TYPE = gql`
subscription ($roleId: uuid!){
  Users_aggregate(where: {roleId: {_eq: $roleId}}){
    aggregate{count}
  }
}`
export const SUBSCRIBE_SALES_EXECUTIVE_COUNT = gql`
subscription allSalesExecutiveCount{
  allSalesExecutiveCount: Users_aggregate(where: {roleId: {_eq: "${Constants.UserRoles.SalesExecutive}"}}){
    aggregate{count}
  }
}`